import { t } from 'i18next';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../../components/Modal';
import { Order } from '../../../../../types/apiResponse/order';
import OrderDetailsContent, { OrderDetailsTab } from './OrderDetailsContent';
import { messages, Translate } from './messages';
import { OrderMoneyPrecisionProvider } from '../../OrderMoneyPrecision';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  order: Order;
  initialTab?: OrderDetailsTab;
  onPendenciesChanged?: () => void;
};

const OrderDetailsModal = ({ showModal, closeModal, order, initialTab, onPendenciesChanged }: Props) => {
  const { i18n } = useTranslation();
  const pendenciesChanged = useRef(false);
  const language = (i18n.resolvedLanguage || i18n.language || 'pt').startsWith('en') ? 'en' : 'pt';
  const l: Translate = (key) => messages[language][key];
  return (
    <OrderMoneyPrecisionProvider>
      <Modal
        title={`${t('orderDetails')}: ${order.NumeroPedido}`}
        showModal={showModal}
        closeModal={() => {
          closeModal();
          if (pendenciesChanged.current) onPendenciesChanged?.();
        }}
        onlyCloseButton
        style={{ width: '1100px', height: '80vh' }}
        bodyStyle={{
          position: 'absolute',
          top: '4rem',
          bottom: '4rem',
          padding: 0,
          overflow: 'hidden',
        }}
        maximized
      >
        <OrderDetailsContent
          key={order.NumeroPedido}
          order={order}
          initialTab={initialTab}
          onPendenciesChanged={() => { pendenciesChanged.current = true; }}
          l={l}
          locale={language === 'en' ? 'en-US' : 'pt-BR'}
        />
      </Modal>
    </OrderMoneyPrecisionProvider>
  );
};

export default OrderDetailsModal;
